module.exports = __webpack_public_path__ + "static/media/tools-3.3b4df581.jpg";